import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { useApi } from '@fortem-monorepo/react-spa'
import { DataUpload } from '@fortem-monorepo/web-sdk'

import { toastApiError } from '@/lib/error-toast'

export const useInvalidationFundsMetadata = () => {
  const queryClient = useQueryClient()

  return {
    invalidate: () => queryClient.invalidateQueries({ queryKey: ['data-upload', 'metadata'] }),
  }
}

export const useUploadDataMutation = () => {
  const api = useApi()

  const { invalidate } = useInvalidationFundsMetadata()

  return useMutation({
    mutationFn: (data: DataUpload.DataUploadBody) => {
      return api.dataUpload.uploadData(data)
    },
    onSuccess: (_data, _params) => {
      toast.success(`Upload successful`)
    },
    onError: (error, _params) => {
      toastApiError(
        error,
        `Error uploading ${_params.liquidity_report?.length ? 'liquidity report' : 'rating'} files`,
      )
    },
    onSettled: (_data, _error, _params) => {
      return invalidate()
    },
  })
}

export const useUpdateFundsMetadataMutation = () => {
  const api = useApi()

  const { invalidate } = useInvalidationFundsMetadata()

  return useMutation({
    mutationFn: (body: DataUpload.UpdateFundsMetadataBody) => {
      return api.dataUpload.updateFundsMetadata(body)
    },
    onSuccess: (_data, _params) => {
      toast.success(`Update successful`)
    },
    onError: (error, params) => {
      toastApiError(error, `Error updating ${params.oldValue} to ${params.newValue}`)
    },
    onSettled: () => {
      invalidate()
    },
  })
}
